// Copyright © Veeam Software Group GmbH

export enum Product {
    Exchange = 'Exchange',
    OneDrive = 'OneDrive',
    SharePoint = 'SharePoint',
    Teams = 'Teams',
}
